import {
    getAxios,
} from './axios'

import {addAuthTokenData} from './member';

export function getMemberAmateurFilms(params = {}) {
    let axios = getAxios();

    return axios.request({
        url: '/member/amateur_films/',
        method: 'get',
        params: {...addAuthTokenData(params)}
    });
}


// WEBPACK FOOTER //
// ./src/backend-helpers/memberAmateurFilms.js